export default __webpack_public_path__ + "static/media/be305e31aed8f29e.54653abca68aa6b3f64586676141473d.svg";